import { render, staticRenderFns } from "./new copy更改拖拽前.vue?vue&type=template&id=61ab7919&scoped=true"
import script from "./new copy更改拖拽前.vue?vue&type=script&lang=js"
export * from "./new copy更改拖拽前.vue?vue&type=script&lang=js"
import style0 from "./new copy更改拖拽前.vue?vue&type=style&index=0&id=61ab7919&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ab7919",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\华水\\hsmanagementsystem\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61ab7919')) {
      api.createRecord('61ab7919', component.options)
    } else {
      api.reload('61ab7919', component.options)
    }
    module.hot.accept("./new copy更改拖拽前.vue?vue&type=template&id=61ab7919&scoped=true", function () {
      api.rerender('61ab7919', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hdyblstj/new copy更改拖拽前.vue"
export default component.exports